import * as angular from 'angular';
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {BatchDialogService} from "../../../batch/services/batch-dialogs-service.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ImportRecurringServicesViewCtrl implements IController {
  services: any;

  private group: any;
  private selectedIds: any;
  private viewServices: any;
  private totals: any;
  private queryString: any;
  private currentNavItem: any;

  /* @ngInject */
  constructor(private deliveriesDialogService: DeliveriesDialogService, private batchDialogService: BatchDialogService, private deliveriesAlertsService: DeliveriesAlertsService,
              private confirmDialogService: ConfirmDialogService, private confirmChangeStateService: ConfirmChangeStateService, private deliveriesConstants,
              private splitService, private $log, private UUIDService, private batchRequestsService: BatchRequestsService,
              private bringozLoaderService: BringozLoaderService, private $q: IQService, private $state) {
  }

  $onInit() {
    if (!this.services) {
      this.services = [];
    }

    this.group = 'total';
    this.selectedIds = [];
    this.viewServices = [];
    this.totals = {};
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onGroupChange(group) {
    this.group = group;

    this.selectedIds = [];
    this._setViewServicesByGroup(group);
  }

  onUpload(event) {
    this.deliveriesDialogService.importRecurringServices(event)
      .then((services) => {
        this._updateServices(this.services.concat(services));
        this.confirmChangeStateService.setIsEnabled(true);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to upload file @uploadDeliveriesButton@onUpload', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
  }

  onQueryChange(query) {
    this.queryString = query;
  }

  onSelectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  onEditService(service, $event) {
    this.deliveriesDialogService.editRecurringService($event, service.entity, false, true)
      .then((editedServiceTemplate) => {
        const serviceCopy = angular.copy(service);
        serviceCopy.entity = editedServiceTemplate;
        serviceCopy.mappingErrors = [];

        var updatedServiceIndex = _.findIndex(this.services, (s: any) => {
          return s.rowNumber === serviceCopy.rowNumber;
        });

        if (updatedServiceIndex > -1) {
          var servicesCopy = angular.copy(this.services);
          servicesCopy.splice(updatedServiceIndex, 1, serviceCopy);
          this._updateServices(servicesCopy);
        }

      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  // function onSaveEditingService(editingService) {
  //     var updatedServiceIndex = _.findIndex(ctrl.services, function(s) {
  //         return s.rowNumber === editingService.rowNumber;
  //     });
  //
  //     if (updatedServiceIndex > -1) {
  //         var servicesCopy = angular.copy(ctrl.services);
  //         servicesCopy.splice(updatedServiceIndex, 1, editingService);
  //         _updateServices(servicesCopy);
  //     }
  // }

  onRemoveServices(ids) {
    const updatedServices = _.filter(this.services, (s) => {
      return _.indexOf(ids, s.rowNumber) === -1;
    });
    this.selectedIds = [];
    this._updateServices(updatedServices);
  }

  onCancel(event) {
    return this.confirmDialogService.confirm('Cancel Upload', 'Are you sure you want to cancel upload and reset all services?', event)
      .then(() => {
        this.totals = {};
        this.currentNavItem = 'total';
        this.selectedIds = [];

        this._updateServices([]);
        this.confirmChangeStateService.reset();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreate(event) {
    const services = _.map(angular.copy(this.services), (s) => {
      return s.entity;
    });
    const serverErrorsCount = this._getWarningErrors(services).length;
    this._confirmCreate(serverErrorsCount, event)
      .then(() => {
        this.bringozLoaderService.on();
        return this.batchRequestsService.createRecurringServicesBatch(this.services);
      })
      .then((batch) => {
        this.bringozLoaderService.off();
        return this.batchDialogService.batchRecurringServicesProgress(event, batch);
      })
      .then((errorItems) => {
        if (errorRowNumbers && errorRowNumbers.length) {

          var errorRowNumbers = _.map(errorItems, 'rowNumber');
          var errorServices = _.chain(this.services)
            .filter((o) => {
              return _.includes(errorRowNumbers, o.rowNumber)
            })
            .map((filteredService) => {
              const errorItem = _.find(errorItems, (errorItem) => {
                return filteredService.rowNumber === errorItem.rowNumber;
              })
              filteredService.mappingErrors = _.get(errorItem, 'mappingErrors', []);
              return filteredService;
            })
            .value();

          // var services = _.filter(ctrl.services, function(s) {
          //     return _.includes(errorRowNumbers, s.rowNumber)
          // })

          this._updateServices(errorServices);
        } else {
          this.confirmChangeStateService.reset();
          this.$state.go('recurring-services');
        }
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.createDeliveriesError();
          this.$log.error('Failed to create batch @uploadDeliveriesView@onCreate', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  onDownloadExample() {
    const downloadUrl = this.deliveriesConstants.importRecurringServicesSampleFileLink;
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = "import-services-example.xls";
    document.body.appendChild(a);
    a.click();
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getTotals(services) {
    const errors = _.reduce(services, (sum, service) => {
      const error = _.find(_.get(service, 'mappingErrors', []), (error) => {
        return error.type === 'Error';
      });
      return sum + (error ? 1 : 0);
    }, 0);
    const warnings = _.reduce(services, (sum, service) => {
      const warning = _.find(_.get(service, 'mappingErrors', []), (error) => {
        return error.type === 'Warning';
      });
      return sum + (warning ? 1 : 0);
    }, 0);
    return {
      total: services.length,
      errors: errors,
      warnings: warnings
    }
  }

  private _updateServices(services) {
    if (!services) {
      services = [];
    }
    this.services = angular.copy(services);
    this.totals = this._getTotals(this.services);

    this._setViewServicesByGroup(this.group);
  }

  private _setViewServicesByGroup(group) {
    let viewServices;

    switch (group) {
      case 'errors':
        viewServices = this._getErrorServices(this.services);
        break;
      case 'warnings':
        viewServices = this._getWarningErrors(this.services);
        break;
      default:
        viewServices = angular.copy(this.services);
    }
    this.viewServices = viewServices;
  }

  private _getErrorServices(services) {
    return _.filter(services, (service) => {
      const error = _.find(_.get(service, 'mappingErrors', []), (error) => {
        return error.type === 'Error';
      });
      return !!error;
    });
  }

  private _getWarningErrors(services) {
    return _.filter(services, (service) => {
      const warning = _.find(_.get(service, 'mappingErrors', []), (error) => {
        return error.type === 'Warning';
      });
      return !!warning;
    })
  }

  private _confirmCreate(serverErrorsCount, event) {
    return serverErrorsCount > 0 ?
      this.confirmDialogService.confirm('Unhandled Warning',
        'There are some unhandled warnings, are you sure you want to continue?', event) :
      this.$q.all(undefined);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('importRecurringServicesView', {
    bindings: {
      services: '<?'
    },
    template: require('./import-recurring-services-view.html').default,
    controller: ImportRecurringServicesViewCtrl
  });
